import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from 'app/auth/models';

@Injectable()
export abstract class AuthenticationService {
    public currentUser$!: Observable<User | null>;

    public abstract logout(redirect?: boolean, sendToBackend?: boolean): Observable<void>;
    public abstract isNewPasswordRequired(): boolean;
    public abstract get currentUserValue(): User | null;
    public abstract isLoggedIn(refreshStorage?: boolean): Observable<boolean>;
    public abstract forgotPassword(email: string): Observable<string>;
    public abstract confirmRegistration(username: string, verificationCode: string): Observable<string>;
    public abstract resetPassword(username: string, verificationCode: string, newPassword: string): Observable<string>;
    public abstract signUp(
        email: string,
        password: string,
        firstName: string,
        lastName: string,
        userLanguage: string,
        companyName: string,
    ): Observable<string>;
    public abstract resendCode(email: string): Observable<string>;
    public abstract newPasswordRequired(newPassword: string): Observable<User | undefined>;
    public abstract login(email: string, password: string): Observable<User | string>;
    public abstract updateUserAttributes(
        firstName: string,
        lastName: string,
        phoneNumber: string,
        role: string,
    ): Observable<User | string>;
    public abstract changePassword(oldPassword: string, newPassword: string): Observable<string>;
    // password is necessary because we want auto signin. If we didn't want it, then password isn't necessary to store in RAM (NOT in localStorage)
    public abstract beginValidation(username: string, password: string): void;
    public abstract getUserToValidate(): { username: string; password: string } | undefined;
    public abstract endValidation(): void;
}
